import RedirectionPageOTP from '@/pages/user/RedirectionPageOTP.vue'

export default [
  {
    path: '/profile/',
    component: require('@/pages/user/CMProfile.vue')
  },
  {
    path: '/profile/edit',
    component: require('@/pages/user/CMProfileEdit.vue')
  },
  {
    path: '/profile/changePassword',
    component: require('@/pages/user/CMChangePassword.vue')
  },
  {
    path: '/login/',
    component: require('@/pages/user/CMLogin.vue')
  },
  {
    path: '/OTP/:email/:otp/:ressource',
    alias: [],
    component: RedirectionPageOTP
  },
  {
    path: '/register/:FirstName/:LastName/:Login/:Password',
    component: require('@/pages/user/CMRegister.vue')
  },
  {
    path: '/register/',
    component: require('@/pages/user/CMRegister.vue')
  }
]



// WEBPACK FOOTER //
// ./src/routes/user.js